module.exports = __webpack_public_path__ + "static/media/left_arrow.14268c17.svg";